import { render, staticRenderFns } from "./myDetail.vue?vue&type=template&id=03563bba&scoped=true"
import script from "./myDetail.vue?vue&type=script&lang=js"
export * from "./myDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03563bba",
  null
  
)

export default component.exports